import {HwOpening} from "../../../../../api/Hardware";
import {Dot, LogiCtrlStoplightButton} from "./OpeningCell";
import {useMemo, useState} from "react";
import {LogiCtrlHwModal} from "./LogiCtrlHwModal";
import {OpeningLogiCtrlStatus} from "../../../../../api/Openings";
import {useReloader} from "../../hardware/ReloadContext";


export function LogiCtrlHwGroup(props: {
    name: string;
    openings: Partial<HwOpening>[];
}) {
    const [show, setShow] = useState<HTMLElement|null>(null);
    const reload = useReloader();

    let anyError: any = null;
    let anyEdited = false;

    props.openings.forEach(op => {
        if(!op.logictrl) return;
        if(op.logictrl.hardwareError) {
            anyError = op.logictrl.hardwareError;
        }

        if(op.logictrl.hardwareEdited) {
            anyEdited = true;
        }
    })

    const status = useMemo(() => {
        return {
            frameEdited: false,
            frameError: null,
            anchorsEdited: false,
            anchorsError: null,
            doorEdited: false,
            doorError: null,
            hardwareEdited: anyEdited,
            hardwareError: anyError,
        } as OpeningLogiCtrlStatus
    }, [anyEdited, anyError])

    return (
        <>
            <LogiCtrlStoplightButton onClick={(e) => {
                e.stopPropagation();
                setShow(e.currentTarget);
            }}>
                <Dot edited={anyEdited} error={anyError} />
            </LogiCtrlStoplightButton>
            {show && <LogiCtrlHwModal
                value={status}
                anchorEl={show}
                onClose={() => setShow(null)}
                openings={props.openings.map(op => op.id) as number[]}
                name={props.name}
                onReload={() => {
                    reload.current();
                }}
            />}
        </>
    )
}